<template>
	<div>
		<ConfettiExplosion
			:particle-count="200"
			:force="0.4"
			:duration="4000"
		/>

		<PartyPopper class="mx-auto size-16 text-won-green" />

		<h2 class="mt-6 text-center text-[20px] leading-[28px] font-semibold text-gray-900">
			Congratulations!
		</h2>
		<p class="mt-0.5 text-center text-[14px] leading-[20px] font-normal text-gray-500">
			That is exactly what this is all for, and we’re really happy for you.
			Mind if our team reaches out, we would love to hear your story?
		</p>

		<div class="mt-4 flex items-center justify-center gap-2">
			<input
				id="cancellation-contact-opt-in"
				v-model="contactOptIn"
				type="checkbox"
				class="size-4 rounded border-gray-300 text-won-green focus:ring-0"
			/>
			<label
				for="cancellation-contact-opt-in"
				class="cursor-pointer text-[14px] leading-[20px] font-medium text-gray-900"
			>
				Yes, you can contact me
			</label>
		</div>

		<button
			type="button"
			:disabled="isSubmitting"
			class="
				mx-auto mt-6 flex h-9 w-full max-w-[320px] items-center justify-center rounded-md
				bg-won-green px-3 text-[16px] leading-[20px] font-medium text-white
				hover:bg-won-green-dark disabled:cursor-default
			"
			@click="emit('continue', contactOptIn)"
		>
			<template v-if="isSubmitting">
				<LoadingIcon margin="" />
			</template>
			<template v-else>
				Continue
			</template>
		</button>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import ConfettiExplosion from 'vue-confetti-explosion';
import { PartyPopper } from 'lucide-vue-next';

import LoadingIcon from '../../../../icons/loading-spinner.vue';

defineProps({
	isSubmitting: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(['continue']);

// Pre-checked: the branch asks for permission to celebrate with the user, and the CX
// team's outreach (EN-890) reads whatever this ends up as off the cancellation record.
const contactOptIn = ref(true);
</script>
